/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { InventoryImage, SecurityHelper, Button } from 'sarsaparilla';
import { authModalActions } from 'shared-ui/auth/redux';

const propTypes = {
    addToCart: PropTypes.func.isRequired,
    permit: PropTypes.object.isRequired,
    disableButtons: PropTypes.bool,
    buttonLabel: PropTypes.string,
    openLoginModal: PropTypes.func.isRequired,
};

const defaultProps = {
    disableButtons: false,
    buttonLabel: 'Continue',
};

class ReservationSidebar extends React.Component {
    constructor(props) {
        super(props);
        this.onClickAdd = this.onClickAdd.bind(this);
    }

    onClickAdd() {
        const loggedin = SecurityHelper.isLoggedIn();
        if (!loggedin) {
            this.props.openLoginModal();
        } else {
            this.props.addToCart(true);
        }
    }

    render() {
        return (
            <div className="permit-right-rail">
                <div className="permit-aside-header">
                    <InventoryImage type="asset" id={this.props.permit.id} />
                </div>

                <div className="rec-aside-body">
                    <div className="rec-aside-card-content">
                        <div className="permit-aside-header">
                            {this.props.permit.name}
                        </div>

                        <div className="permit-aside-header">- Permit</div>

                        <Button
                            id="add-permit-to-cart-button"
                            shouldFitContainer
                            onClick={this.onClickAdd}
                            disabled={this.props.disableButtons}
                            className="rec-button-primary-large"
                            type="button"
                        >
                            {this.props.buttonLabel}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

ReservationSidebar.propTypes = propTypes;
ReservationSidebar.defaultProps = defaultProps;

function mapDispatchToProps(dispatch) {
    return {
        openLoginModal: bindActionCreators(authModalActions.openLoginModal, dispatch),
    };
}

export default connect(null, mapDispatchToProps)(ReservationSidebar);
